module.exports = __webpack_public_path__ + "static/media/chess-queen.766cbd76.svg";